/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChevronDoubleUp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.65 13 19 11.261 12 5l-7 6.261L6.35 13 12 7.946zm0 6L19 17.261 12 11l-7 6.261L6.35 19 12 13.946z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChevronDoubleUp as ChevronDoubleUp };
